// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__I0_Rz","icon":"style_icon__t7-62"};